

import category from ".";
import { toggleModal, ADD_REDEEMS_REQUEST_TO_LIST, ADD_REDEEM_REQUEST_TO_LIST, UPDATE_REDEEM_REQUEST_IN_LIST, DELETE_REDEEM_REQUEST_FROM_LIST } from "./mutation-types";

export default {

        [toggleModal]: (state, value) =>{
            state.isShowAddOrUpdateModal = value;
        },

        [ADD_REDEEMS_REQUEST_TO_LIST]: (state, redeemsList) =>{
            state.redeemsList = redeemsList ;
        },
        
        [ADD_REDEEM_REQUEST_TO_LIST]: (state, redeem) =>{
            state.redeemsList.push(redeem);
        },

        [UPDATE_REDEEM_REQUEST_IN_LIST]: (state, updatedRedeem) =>{
            const index = state.redeemsList.findIndex(redeem => redeem.id === updatedRedeem.id);
            const updatedObject = {...state.redeemsList[index], ...updatedRedeem}
            state.redeemsList[index] = updatedObject
        },

        [DELETE_REDEEM_REQUEST_FROM_LIST]: (state, categoryIDs) => {
            state.redeemsList.forEach((element, index) => { 
            if(element.id == categoryIDs){
                state.redeemsList.splice(index, 1);
            }
            });

          },
          
}
